import { EditBonusProgram } from 'features/bonus/edit-bonus-program';

export function EditBonusProgramPage() {
  return <EditBonusProgram />;
}
